"use client";
import React, { useEffect } from "react";
import AppLayoutDoctor from "../../../navigation/Layout/LayoutDoctor";
import "./Perscription.css";
import PrescriptionLayout from "../../components/PerscriptionLayout/PerscriptionLayout";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentDoctor } from "../../../authDoctor/redux/thunks/doctorsThunks";

export default function Description() {
  const dispatch = useDispatch();

  // Get current doctor data from Redux store
  const { user: currentUser, loading: userLoading, error: userError } = useSelector(
    (state) => state.doctor || {}
  );

  // Fetch current doctor on mount (from cookie session)
  useEffect(() => {
    dispatch(getCurrentDoctor());
  }, [dispatch]);

  return (
    <AppLayoutDoctor>
      <div className="page-content">
        {/* MAIN PRESCRIPTION LAYOUT (includes submenu) */}
        <PrescriptionLayout />
      </div>
    </AppLayoutDoctor>
  );
}